<app-validate-button
  *ngIf="showAllButton"
  [entityType]="entityType"
  [entityId]="entityId"
  [entityObjectId]="entityObjectId"
  [styleClass]="styleClass"
  (results)="onResults($event)"
></app-validate-button>
<app-validation-results-panel
  *ngIf="validationResult"
  [result]="validationResult"
  (cleared)="validationResult = null"
></app-validation-results-panel>
